<template>
  <div class="contact-way">
    <p class="phone">
      <img src="../../assets/images/partner-img/8.png" alt="">联系方式：400-6556-376
    </p>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  }
}
</script>

<style lang="less" scoped>
  .phone{
      font-size: 0.2rem;
      font-family: PingFang SC;
      font-weight: 300;
      color: #A7A7A7;
      text-align: center;
      line-height: .2rem;
      margin-top: .7rem;
      margin-bottom: .3rem;
      img{
        width: .17rem;
        height: .19rem;
        margin-right: .2rem;
      }
    }
</style>